import { type FunctionComponent, type ReactNode } from 'react'

import StarIcon from 'views/components/atoms/StarIcon'
import { MAX_RATING } from 'views/components/molecules/StarRating/consts'

type ItemStarsArguments = {
  rating: number
}

const ItemStars: FunctionComponent<ItemStarsArguments> = ({ rating }) => {
  if (rating === 0) {
    return <span>&nbsp;</span>
  }

  const stars: ReactNode[] = []

  const roundedRating = Math.min(Math.round(rating), MAX_RATING)
  for (let i = 0; i < roundedRating; i += 1) {
    stars.push(<StarIcon filled key={`filled-star-${i}`} size="x-small" />)
  }

  const zeroStars = 5 - roundedRating
  if (zeroStars) {
    for (let i = 0; i < zeroStars; i += 1) {
      stars.push(<StarIcon key={`zero-star-${i}`} size="x-small" />)
    }
  }

  return (
    <span>
      {stars}
      <sup className="u-color--dark u-font-weight--normal">27</sup>
    </span>
  )
}

export default ItemStars
